<template>
  <el-card class="box-card">
    <div
        slot="header"
        class="clearfix">
      <span class="header-item">Linked Devices</span>
      <span class="ring-card__header-buttons">
        <small>
          <RefreshButton @click.native="fetchLinks()" />
        </small>
      </span>
    </div>
    <div
        v-loading="loading"
        class="card-content">
      <el-table
          :data="links"
          class="device-setup-table"
          style="width: 100%">
        <el-table-column
            label="Trigger Event">
          <template slot-scope="scope">
            <span>{{ scope.row.event }}</span>
          </template>
        </el-table-column>

        <el-table-column
            label="Linked to">
          <template slot-scope="scope">
            <el-link
                type="primary"
                target="_self"
                :underline="false"
                :href="`/customer/${customerId}/devices/${scope.row.object.id}`">
              {{ scope.row.object.id }}
            </el-link>
          </template>
        </el-table-column>

        <el-table-column
            label="Linked Device Action">
          <template slot-scope="scope">
            <span>{{ scope.row.action }}</span>
          </template>
        </el-table-column>

        <el-table-column
            label="Duration">
          <template slot-scope="scope">
            <span>{{ scope.row.metadata.duration_seconds }} seconds</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </el-card>
</template>

<script>
import RefreshButton from "@/containers/Customer/RefreshButton";

import { createNamespacedHelpers as h } from "vuex";
const { mapGetters, mapActions } = h("db/device");

export default {
  name: "DeviceLinks",
  components: {
    RefreshButton,
  },
  data() {
    return {
      loading: false,
      links: [],
    };
  },
  computed: {
    ...mapGetters(["doorbotId"]),
    customerId() {
      return this.$store.getters["db/account/customerId"];
    },
  },
  created() {
    this.fetchLinks();
  },
  methods: {
    ...mapActions(["loadLinks"]),
    fetchLinks() {
      this.loading = true;
      this.loadLinks({ doorbotId: this.doorbotId })
        .then((links) => {
          this.links = links;
        })
        .catch((error) => console.error(error))
        .finally(() => (this.loading = false));
    },
  },
};
</script>

<style lang="scss">
.device-setup-table {
  .setup-id {
    display: block;
    color: $--color-curious-blue;
  }
  .device-name {
    color: $--color-silver;
  }
  .setup-date {
    display: block;
    color: $--color-silver;
  }
  .inactive-device__icon {
    color: transparentize($--color-silver, 0.6);
  }
  .active-device__icon {
    color: transparentize($--color-fun-green, 0.6);
  }
}
.setups-table__footer-pagination {
  margin: 40px 0 20px;
}
</style>
